import * as types from './constants';

export const clearSearch = () => ({
  type: types.CLEAR_SEARCH
});

/* =============================================================================
=    API [GET] - Search users
============================================================================= */
const requestSearch = () => ({
  type: types.REQUEST_SEARCH
});

const receiveSearch = results => ({
  type: types.RECEIVE_SEARCH,
  results
});

export const fetchSearch = query => async function (dispatch) {

  dispatch(requestSearch());

  try {
    const response = await fetch(`/api/ldap/users?search=${query}`, {
      credentials: 'same-origin'
    });
    const results = await response.json();

    dispatch(receiveSearch(results));
  } catch (err) {
    throw new Error(err.message);
  }
};
